import React, { useState } from "react";
import { Box, FormControl, Select, MenuItem, InputLabel } from "@mui/material";

const CustomSelect = ({
  label,
  options,
  value,
  onChange,
  name,
  placeholder,
  MenuProps,
}) => (
  <Box sx={{ width: "100%" }}>
    <InputLabel
      sx={{
        mb: 1,
        fontWeight: 500,
        fontSize: 15,
        color: "#ffffff",
        // letterSpacing: ".89px",
      }}
    >
      {label}
    </InputLabel>

    <FormControl fullWidth>
      <Select
        displayEmpty
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        MenuProps={MenuProps}
        sx={{
          backgroundColor: "#fff",
          borderRadius: placeholder ? "20px" : "12px",
          fontWeight: 600,
          fontSize: 16,
          color: value ? "#000" : "#999",

          "& .MuiSelect-select": {
            py: 1.5,
            px: 2,
          },

          /* Remove notch gap */
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ccc",
            borderRadius: placeholder ? "20px" : "12px",
          },

          /* Hover */
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#fd0000",
          },

          /* Focus */
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#fd0000",
            borderWidth: "2px",
          },

          /* Remove default padding */
          "& .MuiOutlinedInput-input": {
            paddingLeft: "16px",
          },

          /* Prevent blue glow */
          "&.Mui-focused": {
            backgroundColor: "#fff",
          },
        }}

      >
        <MenuItem disabled value="">
          {name}
        </MenuItem>
        {options.map((option, idx) => (
          <MenuItem key={idx} value={option} sx={{
            backgroundColor: "#fff",
            color: "#000",

            "&.Mui-selected": {
              backgroundColor: "#fd0000 !important",
              color: "#fff",
              fontWeight: 600,
            },

            "&.Mui-selected:hover": {
              backgroundColor: "#e60000",
            },

            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          }}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
);

export default CustomSelect;
